export default __webpack_public_path__ + "static/social-card-61140c5f70db38606f55dcd5df5fbaf5.png";